import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const GalleryPage = () => (
  <Layout>
    <SEO title="HoOme" />
    <div style={{ paddingTop: "120px" }}>galeria here</div>
  </Layout>
)

export default GalleryPage
